import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../../../region/types/Country";
import {OfferLocationLinksItem} from "../../../atoms/OfferListLocationLinksItem";
import {offerUrlBuilder} from "../../../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital} from "../../../helpers/OfferType";
import {OfferType} from "../../../types/OfferType";
import {offerPluralBase} from "../../../utils/offer_plural";
import {IVoivodeshipRegion} from "../../actions/fetch_offer_list_recommended_regions";

export interface IProps {
    offerType: OfferType | null;
    voivodeshipTopCities: IVoivodeshipRegion[];
    country?: number | null;
}

export const OfferListLocationVoivodeshipTopCitiesLinks: React.FC<IProps> = (props) => {
    const {offerType, voivodeshipTopCities, country} = props;
    return (
        <>
            {voivodeshipTopCities.map((region) => {
                if (region.properties_count < 1) {
                    return;
                }
                const {friendlySlug, countrySlug} = offerUrlBuilder({type: offerType, region: region.slug, country: country});
                let link = rpAppLink.offer.listFriendly({friendlySlug: friendlySlug});
                if (country == Country.SPAIN) {
                    link = rpAppLink.offer.listFriendlyAbroad({
                        friendlySlug: friendlySlug,
                        country: countrySlug,
                        abroadRegionSlug: region.slug
                    });
                }
                const linkText = `${
                    offerType
                        ? offerType !== OfferType.COMMERCIAL
                            ? `${getOfferTypeNamePluralCapital(offerType)} na sprzedaż`
                            : getOfferTypeNamePluralCapital(offerType)
                        : "Nieruchomości"
                } ${region.name} (${region.properties_count} ${offerPluralBase(region.properties_count)})`;

                return <OfferLocationLinksItem disableSelfLinking linkText={linkText} url={link} key={region.id} />;
            })}
        </>
    );
};
import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../../../region/types/Country";
import {OfferLocationLinksItem} from "../../../atoms/OfferListLocationLinksItem";
import {offerUrlBuilder} from "../../../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital} from "../../../helpers/OfferType";
import {OfferType} from "../../../types/OfferType";
import {offerPluralBase} from "../../../utils/offer_plural";
import {IVoivodeshipRegion} from "../../actions/fetch_offer_list_recommended_regions";

export interface IProps {
    offerType: OfferType | null;
    voivodeshipTopCities: IVoivodeshipRegion[];
    country?: number | null;
}

export const OfferListLocationVoivodeshipTopCitiesLinks: React.FC<IProps> = (props) => {
    const {offerType, voivodeshipTopCities, country} = props;
    return (
        <>
            {voivodeshipTopCities.map((region) => {
                if (region.properties_count < 1) {
                    return;
                }
                const {friendlySlug, countrySlug} = offerUrlBuilder({type: offerType, region: region.slug, country: country});
                let link = rpAppLink.offer.listFriendly({friendlySlug: friendlySlug});
                if (country == Country.SPAIN) {
                    link = rpAppLink.offer.listFriendlyAbroad({
                        friendlySlug: friendlySlug,
                        country: countrySlug,
                        abroadRegionSlug: region.slug
                    });
                }
                const linkText = `${
                    offerType
                        ? offerType !== OfferType.COMMERCIAL
                            ? `${getOfferTypeNamePluralCapital(offerType)} na sprzedaż`
                            : getOfferTypeNamePluralCapital(offerType)
                        : "Nieruchomości"
                } ${region.name} (${region.properties_count} ${offerPluralBase(region.properties_count)})`;

                return <OfferLocationLinksItem disableSelfLinking linkText={linkText} url={link} key={region.id} />;
            })}
        </>
    );
};
